/**
 * "Novedades de cumplimiento" — curated regulatory news for the Registro home.
 * Demo content: real Panama AML/CFT bodies and themes (SBP, UAF, Intendencia,
 * GAFI/GAFILAT, MEF). Static seed, no backend.
 */
export interface NewsItem {
  source: string;
  dateISO: string;
  title: string;
  url: string;
}

export const NEWS: NewsItem[] = [
  {
    source: 'SBP',
    dateISO: '2026-05-14',
    title: 'Acuerdo No. 1-2026: nuevas obligaciones de debida diligencia para otros sujetos supervisados',
    url: 'https://www.superbancos.gob.pa/',
  },
  {
    source: 'UAF',
    dateISO: '2026-04-22',
    title: 'Nueva guía de señales de alerta y reporte de operaciones sospechosas (ROS)',
    url: 'https://www.uaf.gob.pa/',
  },
  {
    source: 'GAFI',
    dateISO: '2026-02-13',
    title: 'Panamá se mantiene fuera de la lista gris en la actualización de jurisdicciones bajo monitoreo',
    url: 'https://www.fatf-gafi.org/en/publications/High-risk-and-other-monitored-jurisdictions/increased-monitoring-february-2026.html',
  },
  {
    source: 'Intendencia',
    dateISO: '2026-03-03',
    title: 'Recordatorio: actualización del Registro Único de Beneficiarios Finales (RUBF)',
    url: 'https://www.intendencia.gob.pa/',
  },
  {
    source: 'UAF',
    dateISO: '2026-02-05',
    title: 'Taller de actualización en prevención de BC/FT para oficiales de cumplimiento',
    url: 'https://www.uaf.gob.pa/',
  },
  {
    source: 'MEF',
    dateISO: '2026-01-20',
    title: 'Panamá permanece fuera de la lista de países de alto riesgo de la Unión Europea',
    url: 'https://www.mef.gob.pa/',
  },
];
